export const PASS_WORD = '请输入7-12位，数字和字母组合'
